import React from 'react';
import AuthService from './authService.js';

class TpRunService extends React.Component {
  static ListByPricing(pricingId) {
    const authService = AuthService.getInstance();

    const url = `/api/TpRun/ListByPricing?pricingId=${pricingId}`;

    return authService.CallBackendFunction(url);
  }
}

export default TpRunService;
